// ----------------------------------------------------------------------- react
import { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";

// ------------------------------------------------------------------- internos
import {
  leerTorrecillas, armarSalidas, bitrenesDe, custodiasDeArribos, hojaDeArribos,
  agregarAArribos, textoSalteadas, filasDeEnganche, textoEnganchesGallegos, pelado, HORA, A_GALLEGOS,
  hojaSalidasParaImprimir, nombreSalidas, esFapesa, caractFapesa,
} from "../shared/torrecillas";
import { htmlParaImprimir, imprimirHtml } from "../shared/planillaImprimir";
import {
  hojasDelArchivo, padron, bajarSalidas, cargarEnganches,
  torrecillasDelMail, bajarTorrecillaDelMail,
} from "../services/torrecillas";
import { misPlanillas, traerPlanilla, guardarPlanilla, miMail } from "../services/espacio";
import { hoyAr, horaAr, diaAr } from "../shared/fechaAr";
import SalidasBuenosAires from "../components/satelital/SalidasBuenosAires";
import CorreosDeLaManana from "../components/satelital/CorreosDeLaManana";
import UbicacionPernocte from "../components/satelital/UbicacionPernocte";
import { ponerUbicacionAlAgregar, textoUbicacionAlAgregar } from "../services/ubicacionAlAgregar";
import {
  comunesDeTC, hojaDeArribosFurgones, agregarAArribosFurgones, planillaDeArribosPropuesta,
  hojaDeCortesFurgones, agregarACortesFurgones,
} from "../shared/arribosFurgones";

/* Torrecillas → SALIDAS Y CUST → ONLY BITRENES → Enganches.
 *
 * Ticket #432 (Lautaro Díaz, Satelital, 16/10). Se arrastran las dos
 * Torrecillas que manda Tráfico de Río Grande (TC y TCC) y sale:
 *   · su SALIDAS Y CUST para bajar o imprimir (ticket 452), con la custodia
 *     que él elige por fila;
 *   · los bitrenes sumados a ARRIBOS BITREN de su planilla del hub, sin
 *     repetir los que ya tiene ni escribir debajo de sus celdas combinadas
 *     (si saltea renglones por eso, lo dice);
 *   · los enganches cargados en FlotaBot («Enganches de bitren», los de Río
 *     Gallegos) sin pisar, en el mismo «Agregar … a la planilla» (ticket 562,
 *     Lautaro, 29/10: «QUITALE EL BOTÓN DE VER ENGANCHES, ES UN PASO MÁS SIN
 *     UTILIDAD. QUE CUANDO YO APRETE AGREGAR ENGANCHES A LA PLANILLA (ONLY
 *     BITRENES) SE AGREGUE DIRECTAMENTE TAMBIÉN LOS ENGANCHES»). El
 *     importador de FlotaBot no duplica: apretar dos veces dice «ya
 *     estaban». Si Enganches falla, lo de la planilla queda y se dice;
 *   · los furgones de la de TC sumados a la hoja ARRIBOS de su ARRIBOS Y
 *     CORTES (Lautaro, 21/10: «CUANDO YO TIRE LAS TORRECILLAS DE TC, QUE SE
 *     COMPLETEN EN ARRIBOS DE ARRIBOS Y CORTES»), con las mismas reglas que
 *     los bitrenes: sin repetir ni escribir debajo de sus combinadas, y
 *     después la UBICACIÓN de ahora. Las reglas, en `shared/arribosFurgones`.
 *     Y en el mismo guardado, a su hoja CORTES (Lautaro, 21/10: «Tambien lo
 *     de tc que se agregue en cortes»), con la CUSTODIA según el cliente.
 * Las reglas, en `shared/torrecillas`. Sin textos de ayuda en la pantalla.
 *
 * Arriba de todo, «Actualizar ubicación y pernocte» (Lautaro, 19/10): lo
 * primero que hace a la mañana, sin soltar nada (`UbicacionPernocte`).
 * «Traer las de hoy» (mismo ticket): las dos llegan por mail a cepi@fibot.ar
 * y FlotaBot las guarda tal cual; el botón trae la última de cada empresa y
 * la pasa por el mismo `tomar` que una arrastrada. Lo que falta se dice, y
 * arrastrar queda de respaldo. El día que se trae es SUYO («Del día»): no
 * toca el «Día de carga», que sigue saliendo del título del archivo (si el
 * título no lo dice, el de una del mail es el día que se pidió).
 */

const EMPRESAS_DEL_MAIL = ["TC", "TCC"];
const diaCorto = (iso) => diaAr(iso).slice(0, 5);
const momento = (x) => new Date(x.fecha_mail).getTime() || 0;

/* Lo que se dice de una que se bajó del mail, ya pasada por `tomar`. Si no
 * la tomó (no abrió, o abrió y no la lee), no se cargó: ni «cargué» ni
 * «corregida». */
function notasDeLaBajada({ emp, p, archivo, nueva }, leidos) {
  if (!leidos.includes(archivo)) return [`La de ${emp} llegó pero no se puede leer: arrastrala si la tenés.`];
  const out = [];
  if (p.corregida) out.push(`${emp}: es la corregida de las ${horaAr(p.fecha_mail)}.`);
  if (nueva) {
    out.push(nueva.error
      ? `La de ${emp} de las ${horaAr(nueva.fecha_mail)} no se puede leer: cargué la de las ${horaAr(p.fecha_mail)}. Si tenés otra, arrastrala.`
      : `La de ${emp} de las ${horaAr(nueva.fecha_mail)} todavía no se pudo traer: cargué la de las ${horaAr(p.fecha_mail)}. Si tenés la nueva, arrastrala.`);
  }
  return out;
}

const MEMORIA = "torrecillas.custodias";

function leerMemoria() {
  try {
    return JSON.parse(localStorage.getItem(MEMORIA) || "{}") || {};
  } catch {
    return {};
  }
}

function guardarMemoria(bloques) {
  try {
    const m = leerMemoria();
    for (const b of bloques) {
      for (const f of b.filas) {
        // Los de FAPESA no se recuerdan: salen del día de carga (ticket 611).
        if (f.lugar && f.caract && f.parte?.cual !== 2 && f.caract !== A_GALLEGOS && !esFapesa(f.lugar)) m[f.lugar] = f.caract;
      }
    }
    localStorage.setItem(MEMORIA, JSON.stringify(m));
  } catch {
    /* sin almacenamiento: la próxima vez propone lo de la planilla */
  }
}

const hoyISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export default function SatelitalTorrecillas() {
  const entrada = useRef(null);
  const [encima, setEncima] = useState(false);
  const [lecturas, setLecturas] = useState([]);
  const [datos, setDatos] = useState(null);
  const [fecha, setFecha] = useState("");
  const [hora, setHora] = useState(HORA);
  const [cambios, setCambios] = useState({});
  const [error, setError] = useState("");
  const [planillas, setPlanillas] = useState([]);
  const [planillaId, setPlanillaId] = useState("");
  // Todas las suyas, para elegir la de furgones de las salidas de Buenos
  // Aires (se propone la que se llama ARRIBOS o CORTES), y quién es, para
  // acordarse de cuál eligió.
  const [mias, setMias] = useState([]);
  const [yo, setYo] = useState("");
  const [custodiasPlanilla, setCustodiasPlanilla] = useState({});
  const [aviso, setAviso] = useState("");
  const [avisoUbic, setAvisoUbic] = useState("");
  // Qué «Agregar» es el último: la ubicación de uno viejo no se muestra.
  const vuelta = useRef(0);
  const [ocupado, setOcupado] = useState("");
  // Lo que pasó con Enganches al agregar a la planilla (ticket 562).
  const [avisoEng, setAvisoEng] = useState("");
  const [delMail, setDelMail] = useState([]);
  const [diaDelMail, setDiaDelMail] = useState("");
  // La de TC va a la ARRIBOS de su planilla de furgones, no a la de bitrenes.
  const [furgonesId, setFurgonesId] = useState("");
  const [avisoTC, setAvisoTC] = useState("");
  const [avisoUbicTC, setAvisoUbicTC] = useState("");
  const vueltaTC = useRef(0);
  // Lo último leído del Excel de Gula en «Salidas de Buenos Aires», para el
  // correo del Car-Truck de Buenos Aires (Lautaro, 27/10, ticket 536).
  const [gula, setGula] = useState(null);

  useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        const [lista, yo] = await Promise.all([misPlanillas(), miMail()]);
        const mias = lista.filter((p) => (p.dueno || "").toLowerCase() === yo);
        const bitrenes = mias.filter((p) => pelado(p.nombre).includes("BITREN"));
        if (!vivo) return;
        setPlanillas(bitrenes.length ? bitrenes : mias);
        setPlanillaId((bitrenes[0] || {}).id || "");
        setMias(mias);
        setYo(yo);
      } catch {
        /* sin planillas: sólo se baja el Excel */
      }
    })();
    return () => {
      vivo = false;
    };
  }, []);

  // Se propone su ARRIBOS Y CORTES; si ya eligió otra y sigue estando, ésa.
  useEffect(() => {
    setFurgonesId((actual) => (mias.some((p) => p.id === actual) ? actual : planillaDeArribosPropuesta(mias)));
  }, [mias]);

  useEffect(() => {
    if (!planillaId) return undefined;
    let vivo = true;
    traerPlanilla(planillaId)
      .then((p) => {
        const i = hojaDeArribos(p.datos);
        if (vivo && i >= 0) setCustodiasPlanilla(custodiasDeArribos(p.datos.hojas[i]));
      })
      .catch(() => {});
    return () => {
      vivo = false;
    };
  }, [planillaId]);

  /* Devuelve los archivos que sí leyó (null si uno arrastrado no abrió). `dia`
   * es el que se pidió al mail: si ningún título dice el día, es ése. Del
   * mail (con `dia`), uno que no abre se saltea: queda afuera de lo leído, su
   * empresa lo dice y el de la otra entra igual. Uno arrastrado que no abre
   * es el error de siempre. Lecturas y día van contra lo último, no contra lo
   * de cuando se llamó: mientras el mail trae, se puede arrastrar otra. */
  const tomar = async (archivos, dia = "") => {
    setError("");
    setAviso("");
    setDelMail([]);
    setAvisoEng("");
    const nuevas = [];
    const leidos = [];
    let rotos = 0;
    for (const a of archivos) {
      try {
        const hojas = await hojasDelArchivo(a);
        const l = hojas.map(leerTorrecillas).find((x) => x && x.filas.length);
        if (l) {
          nuevas.push({ ...l, nombre: a.name });
          leidos.push(a);
        }
      } catch {
        if (!dia) {
          setError("No se pudo leer el Excel.");
          return null;
        }
        rotos += 1;
      }
    }
    if (!nuevas.length) {
      setError(rotos ? "No se pudo leer el Excel." : "No es una planilla de Torrecillas.");
      return leidos;
    }
    setLecturas((antes) => [...antes.filter((l) => !nuevas.some((n) => n.empresa === l.empresa)), ...nuevas]);
    setCambios({});
    setFecha((f) => f || nuevas.find((n) => n.fecha)?.fecha || dia || hoyISO());
    if (!datos) {
      try {
        setDatos(await padron());
      } catch {
        setDatos({ tractores: {}, furgones: {} });
      }
    }
    return leidos;
  };

  /* La última de cada empresa del día elegido (o de hoy), como si se hubiera
   * arrastrado. Lo que no está se dice, empresa por empresa; una más nueva
   * que no se pudo usar también, para que no parezca que entró la última.
   * Lo de cada una que se bajó se dice después de leerla: si `tomar` no la
   * tomó, no se cargó. El botón queda tomado hasta que termina `tomar`: un
   * segundo clic no vuelve a pedir lo mismo. Con planillas ya cargadas no
   * anda (antes, Limpiar): el «Día de carga» seguiría siendo el de ésas. */
  const traer = async () => {
    const dia = diaDelMail || hoyAr();
    setOcupado("mail");
    setError("");
    setDelMail([]);
    try {
      const r = await torrecillasDelMail(dia);
      if (!r.ok) {
        setError(r.mensaje || r.error || "No se pudo consultar.");
        return;
      }
      const cuando = dia === hoyAr() ? "Hoy" : `El ${diaCorto(dia)}`;
      const lista = r.planillas || [];
      const sinGuardar = r.sin_guardar || [];
      const notas = []; // texto, o una bajada cuya nota sale después de leerla
      const archivos = [];
      // Lo de los 30 días, una sola vez si el día no trajo nada. Si llegó
      // algo, cada empresa dice lo suyo, y la que no tiene nada, que ya no
      // está: de un día que se puede haber borrado no se dice «no llegó».
      const vencida = r.vencida && !lista.length && !sinGuardar.length;
      let vencidaDicha = false;
      for (const emp of EMPRESAS_DEL_MAIL) {
        const deEsa = lista.filter((x) => x.empresa === emp);
        // Una con error no se pasa nunca, aunque venga marcada como la última.
        const p = deEsa.find((x) => x.es_la_ultima && !x.error);
        if (!p) {
          const sin = sinGuardar.find((x) => x.empresa === emp);
          const otra = (r.otra_fecha || []).find((x) => x.empresa === emp);
          if (vencida) {
            if (!vencidaDicha) {
              notas.push(`Las del correo se guardan 30 días: las del ${diaCorto(dia)} ya no están. Arrastralas si las tenés.`);
            }
            vencidaDicha = true;
          } else if (deEsa.some((x) => x.error)) {
            notas.push(`La de ${emp} llegó pero no se puede leer: arrastrala si la tenés.`);
          } else if (sin) {
            notas.push(`La de ${emp} llegó a cepi@fibot.ar pero no se pudo traer: arrastrala si la tenés.`);
          } else if (otra) {
            notas.push(`La de ${emp} que llegó a las ${horaAr(otra.fecha_mail)} dice ${diaCorto(otra.fecha_planilla)}: si es la de este día, arrastrala.`);
          } else if (r.vencida) {
            notas.push(`La de ${emp} del ${diaCorto(dia)} ya no está: las del correo se guardan 30 días. Arrastrala si la tenés.`);
          } else {
            notas.push(`${cuando} no llegó la de ${emp} a cepi@fibot.ar: arrastrala si la tenés.`);
          }
          continue;
        }
        const b = await bajarTorrecillaDelMail(p.id);
        if (!b.ok) {
          notas.push(`La de ${emp}: ${b.mensaje}`);
          continue;
        }
        const archivo = new File([b.blob], p.nombre || `Torrecillas ${emp}.xlsx`);
        archivos.push(archivo);
        const nueva = [...deEsa.filter((x) => x.error), ...sinGuardar.filter((x) => x.empresa === emp)]
          .filter((x) => momento(x) > momento(p))
          .sort((a, c) => momento(c) - momento(a))[0];
        notas.push({ emp, p, archivo, nueva });
      }
      // Las que no se sabe de qué empresa son no se cargan: se dicen. La que
      // vino con error (no es una Torrecillas, no trae cargas, no abre) no.
      for (const x of [...lista, ...sinGuardar].filter((y) => !y.empresa && !y.error)) {
        notas.push(`Llegó una planilla que no sé de qué empresa es (${x.nombre}, ${horaAr(x.fecha_mail)}): si es una Torrecillas, arrastrala.`);
      }
      const leidos = archivos.length ? await tomar(archivos, dia) : [];
      setDelMail(notas.flatMap((n) => (typeof n === "string" ? [n] : notasDeLaBajada(n, leidos))));
    } finally {
      setOcupado("");
    }
  };

  const bloques = useMemo(() => {
    if (!lecturas.length || !datos) return [];
    const custodias = { ...custodiasPlanilla, ...leerMemoria() };
    return armarSalidas(lecturas, { ...datos, custodias }).map((b) => ({
      ...b,
      filas: b.filas.map((f, i) => {
        const c = cambios[`${b.empresa}-${i}`] || {};
        const g = { ...f, ...c };
        // FAPESA TV / FAPESA TV EXP: las características salen del día de
        // carga (ticket 611), salvo que las haya escrito a mano.
        if (!("caract" in c) && g.parte?.cual !== 2 && esFapesa(g.lugar)) {
          g.caract = caractFapesa(g.lugar, fecha) || g.caract;
        }
        return g;
      }),
    }));
  }, [lecturas, datos, custodiasPlanilla, cambios, fecha]);

  const bitrenes = useMemo(() => bitrenesDe(bloques), [bloques]);
  const comunes = useMemo(() => comunesDeTC(bloques, datos?.furgones), [bloques, datos]);

  const cambiar = (empresa, i, campo, valor) => {
    setCambios((c) => {
      const fila = { ...(c[`${empresa}-${i}`] || {}), [campo]: valor };
      // Pasar a FAPESA TV / TV EXP vuelve a calcular las características.
      if (campo === "lugar" && esFapesa(valor)) delete fila.caract;
      return { ...c, [`${empresa}-${i}`]: fila };
    });
  };

  const bajar = async () => {
    guardarMemoria(bloques);
    try {
      await bajarSalidas(bloques, { fecha, hora });
    } catch {
      setError("No se pudo armar el Excel.");
    }
  };

  /* La misma hoja que se baja, al diálogo de impresión del navegador. */
  const imprimir = () => {
    guardarMemoria(bloques);
    try {
      const hoja = hojaSalidasParaImprimir(bloques, { fecha, hora });
      imprimirHtml(htmlParaImprimir(hoja, hoja.celdas, { titulo: nombreSalidas(fecha) }));
    } catch {
      setError("No se pudo armar la hoja para imprimir.");
    }
  };

  /* La posición de ahora en la UBICACIÓN de los renglones recién agregados
     (Lautaro, 21/10: «que también ponga la posición actual»). Va después de
     guardar y sin esperarla: los bitrenes ya entraron, y si FlotaBot tarda o
     no contesta la UBICACIÓN queda vacía, como antes. */
  const ubicar = async (enLa, hoja, nuevas, mia, { hojaDe = hojaDeArribos, cual = vuelta, decir = setAvisoUbic } = {}) => {
    const r = await ponerUbicacionAlAgregar({ planillaId: enLa, hojaDe, hoja, nuevas });
    if (cual.current === mia) decir(textoUbicacionAlAgregar(r));
  };

  /* Los mismos bitrenes a Enganches (los de Río Gallegos), con el importador
     de FlotaBot, que no duplica ni pisa (ticket 562). Va después de la
     planilla y aparte: si falla, lo de la planilla ya quedó. */
  const enganchar = async (mia) => {
    let r;
    try {
      r = await cargarEnganches(filasDeEnganche(bitrenes, fecha));
    } catch {
      r = null;
    }
    if (vuelta.current !== mia) return;
    setAvisoEng(textoEnganchesGallegos(r));
  };

  const agregar = async () => {
    vuelta.current += 1;
    const mia = vuelta.current;
    setOcupado("planilla");
    setAviso("");
    setAvisoUbic("");
    setAvisoEng("");
    setError("");
    guardarMemoria(bloques);
    let escrita = false;
    try {
      const p = await traerPlanilla(planillaId);
      const i = hojaDeArribos(p.datos);
      if (i < 0) {
        setError("Esa planilla no tiene la hoja de arribos.");
        return;
      }
      const r = agregarAArribos(p.datos.hojas[i], bitrenes, fecha);
      if (r.agregados) {
        const hojas = p.datos.hojas.map((h, j) => (j === i ? r.hoja : h));
        await guardarPlanilla(p.id, p.nombre, { ...p.datos, hojas }, p.actualizado_en);
      }
      escrita = true;
      setAviso(
        `${p.nombre}: ${r.agregados} ${r.agregados === 1 ? "bitren agregado" : "bitrenes agregados"}`
        + (r.yaEstaban ? `, ${r.yaEstaban} ya estaban.` : ".")
        + (r.salteadas.length ? ` ${textoSalteadas(r.salteadas)}` : ""),
      );
      if (r.agregados) ubicar(p.id, r.hoja, r.nuevas, mia);
    } catch {
      setError("No se pudo guardar la planilla. Probá de nuevo.");
    } finally {
      // Enganches también con la planilla ya al día (todos «ya estaban»):
      // no duplica, y así lo de Gallegos se completa aunque falte.
      if (escrita && fecha) await enganchar(mia);
      setOcupado("");
    }
  };

  /* Los furgones de la de TC a las hojas ARRIBOS y CORTES de su planilla de
     furgones: el mismo camino que los bitrenes (traer, sumar sin pisar,
     guardar con el candado de `actualizado_en`), las dos hojas en UN guardado,
     y después la UBICACIÓN de ahora (sólo ARRIBOS la tiene). */
  const agregarTC = async () => {
    vueltaTC.current += 1;
    const mia = vueltaTC.current;
    setOcupado("arribos");
    setAvisoTC("");
    setAvisoUbicTC("");
    setError("");
    guardarMemoria(bloques);
    try {
      const p = await traerPlanilla(furgonesId);
      const i = hojaDeArribosFurgones(p.datos);
      if (i < 0) {
        setError("Esa planilla no tiene la hoja ARRIBOS con D/C y FUR.");
        return;
      }
      const r = agregarAArribosFurgones(p.datos.hojas[i], comunes, fecha);
      const cortes = hojaDeCortesFurgones(p.datos);
      const c = cortes.i >= 0 ? agregarACortesFurgones(p.datos.hojas[cortes.i], comunes, fecha) : null;
      if (r.agregados || c?.agregados) {
        const hojas = p.datos.hojas.map((h, j) => {
          if (j === i && r.agregados) return r.hoja;
          if (j === cortes.i && c.agregados) return c.hoja;
          return h;
        });
        await guardarPlanilla(p.id, p.nombre, { ...p.datos, hojas }, p.actualizado_en);
      }
      const cuenta = (x) => `${x.agregados} ${x.agregados === 1 ? "furgón agregado" : "furgones agregados"}`
        + (x.yaEstaban ? `, ${x.yaEstaban} ya estaban.` : ".")
        + (x.salteadas.length ? ` ${textoSalteadas(x.salteadas, "furgón")}` : "");
      let enCortes = "No tiene la hoja CORTES: ahí no escribí.";
      if (c) enCortes = `En CORTES: ${cuenta(c)}`;
      else if (cortes.sinTitulos) enCortes = "La hoja CORTES no tiene D/C y FUR: ahí no escribí.";
      setAvisoTC(`${p.nombre}: en ARRIBOS, ${cuenta(r)} ${enCortes}`);
      if (r.agregados) {
        ubicar(p.id, r.hoja, r.nuevas, mia, { hojaDe: hojaDeArribosFurgones, cual: vueltaTC, decir: setAvisoUbicTC });
      }
    } catch {
      setError("No se pudo guardar la planilla. Probá de nuevo.");
    } finally {
      setOcupado("");
    }
  };

  const limpiar = () => {
    setDelMail([]);
    setDiaDelMail("");
    vuelta.current += 1;
    vueltaTC.current += 1;
    setAvisoUbic("");
    setAvisoTC("");
    setAvisoUbicTC("");
    setLecturas([]);
    setCambios({});
    setAvisoEng("");
    setAviso("");
    setError("");
    setFecha("");
  };

  return (
    <div>
      <h2 style={{ margin: "0 0 4px" }}>Torrecillas</h2>

      <UbicacionPernocte planillas={planillas} planillaId={planillaId} onPlanilla={setPlanillaId} />

      <p style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <button
          type="button"
          className="tk-boton tk-boton--fuerte"
          disabled={!!ocupado || bloques.length > 0}
          onClick={traer}
        >
          {ocupado === "mail"
            ? "Trayendo…"
            : !diaDelMail || diaDelMail === hoyAr() ? "Traer las de hoy" : `Traer las del ${diaCorto(diaDelMail)}`}
        </button>
        {bloques.length === 0 && (
          <label>
            Del día{" "}
            <input type="date" value={diaDelMail} onChange={(e) => setDiaDelMail(e.target.value)} />
          </label>
        )}
      </p>

      {delMail.length > 0 && (
        <div className="panel-aviso suave">
          {delMail.map((n, i) => (
            // La lista se reemplaza entera: dos notas iguales no chocan.
            <p key={i}>{n}</p>
          ))}
        </div>
      )}

      <div
        className={"planilla-cajon" + (encima ? " planilla-cajon--encima" : "")}
        onDragOver={(e) => {
          e.preventDefault();
          setEncima(true);
        }}
        onDragLeave={() => setEncima(false)}
        onDrop={(e) => {
          e.preventDefault();
          setEncima(false);
          tomar([...(e.dataTransfer.files || [])]);
        }}
      >
        <p className="planilla-cajon__txt">
          Arrastrá las Torrecillas acá
          <br />
          <span className="tk-meta">o</span>
        </p>
        <button type="button" className="tk-boton" onClick={() => entrada.current?.click()}>
          Buscar en el equipo
        </button>
        <input
          ref={entrada}
          type="file"
          accept=".xlsx,.xlsm,.xls"
          multiple
          hidden
          aria-label="Planillas de Torrecillas"
          onChange={(e) => {
            tomar([...(e.target.files || [])]);
            e.target.value = "";
          }}
        />
        {lecturas.map((l) => (
          <p key={l.empresa} className="tk-meta">
            {l.empresa} · {l.nombre} · {l.filas.length} filas
          </p>
        ))}
      </div>

      {error && (
        <div className="panel-aviso suave">
          <p>{error}</p>
        </div>
      )}

      {lecturas.length > 0 && !datos && <p className="tk-meta">Cargando…</p>}

      {bloques.length > 0 && (
        <>
          <p style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
            <label>
              Día de carga{" "}
              <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
            </label>
            <label>
              Hora{" "}
              <input type="text" value={hora} size={8} onChange={(e) => setHora(e.target.value)} />
            </label>
            <button type="button" className="tk-boton" onClick={limpiar}>
              Limpiar
            </button>
          </p>

          {bloques.map((b) => (
            <div key={b.empresa} style={{ overflowX: "auto", marginBottom: 16 }}>
              <h3 style={{ margin: "8px 0" }}>{b.titulo}</h3>
              <table className="tabla fija">
                <thead>
                  <tr>
                    <th>Satelital</th>
                    <th>Tractor</th>
                    <th>Semi</th>
                    <th>Marca</th>
                    <th>Chofer</th>
                    <th>Lugar de carga</th>
                    <th>Características del viaje</th>
                    <th>Bitren</th>
                  </tr>
                </thead>
                <tbody>
                  {b.filas.map((f, i) => (
                    <tr key={`${f.semi}-${i}`}>
                      <td>{f.satelital}</td>
                      <td>{f.tractor} <span className="tk-meta">{f.patTractor}</span></td>
                      <td>{f.semi} <span className="tk-meta">{f.patSemi}</span></td>
                      <td>{f.marca}</td>
                      <td>{f.chofer}</td>
                      <td>
                        <input
                          type="text"
                          value={f.lugar}
                          aria-label={`Lugar de carga de ${f.semi}`}
                          onChange={(e) => cambiar(b.empresa, i, "lugar", e.target.value.toUpperCase())}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={f.caract}
                          aria-label={`Características del viaje de ${f.semi}`}
                          onChange={(e) => cambiar(b.empresa, i, "caract", e.target.value.toUpperCase())}
                        />
                      </td>
                      <td>{f.parte ? (f.parte.cual === 1 ? "1ra" : "2da") : ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}

          <p style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            <button type="button" className="tk-boton tk-boton--fuerte" onClick={bajar}>
              Bajar SALIDAS Y CUST
            </button>
            <button type="button" className="tk-boton" onClick={imprimir}>
              Imprimir
            </button>
          </p>

          {bitrenes.length > 0 && planillas.length > 0 && (
            <p style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
              <select
                value={planillaId}
                onChange={(e) => setPlanillaId(e.target.value)}
                aria-label="Planilla de bitrenes"
              >
                {planillas.map((p) => (
                  <option key={p.id} value={p.id}>{p.nombre}</option>
                ))}
              </select>
              <button
                type="button"
                className="tk-boton"
                disabled={!planillaId || !!ocupado}
                onClick={agregar}
              >
                {ocupado === "planilla" ? "Guardando…" : `Agregar ${bitrenes.length} ${bitrenes.length === 1 ? "bitren" : "bitrenes"} a la planilla`}
              </button>
            </p>
          )}

          {aviso && (
            <div className="panel-aviso suave">
              <p>{aviso}</p>
              {avisoUbic && <p>{avisoUbic}</p>}
              {avisoEng && (
                <p>
                  <span>{avisoEng}</span>{" "}
                  <Link to="/panel/satelital-enganches">Abrir Enganches</Link>
                </p>
              )}
            </div>
          )}

          {comunes.length > 0 && mias.length > 0 && (
            <p style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
              <select
                value={furgonesId}
                onChange={(e) => setFurgonesId(e.target.value)}
                aria-label="Planilla de arribos de TC"
              >
                {mias.map((p) => (
                  <option key={p.id} value={p.id}>{p.nombre}</option>
                ))}
              </select>
              <button
                type="button"
                className="tk-boton"
                disabled={!furgonesId || !!ocupado || !fecha}
                onClick={agregarTC}
              >
                {ocupado === "arribos"
                  ? "Guardando…"
                  : `Agregar ${comunes.length} ${comunes.length === 1 ? "furgón" : "furgones"} de TC a ARRIBOS y CORTES`}
              </button>
            </p>
          )}

          {avisoTC && (
            <div className="panel-aviso suave">
              <p>{avisoTC}</p>
              {avisoUbicTC && <p>{avisoUbicTC}</p>}
            </div>
          )}

        </>
      )}

      {/* El otro sentido: las cargas de Buenos Aires, de la Previsión o del
          Excel de Gula, a SALIDAS BITREN y a la SALIDAS de su planilla de
          furgones (ticket #432, «las Torrecillas de Buenos Aires»; Lautaro,
          20/10, «que te arrastre el excel»). */}
      <SalidasBuenosAires
        planillas={planillas}
        planillaId={planillaId}
        onPlanilla={setPlanillaId}
        planillasFurgones={mias}
        yo={yo}
        onExcelDeGula={setGula}
      />

      {/* Los correos de la mañana: custodia, Car-Truck y posiciones (ticket
          #456). Con las Torrecillas de arriba, sus planillas y las salidas de
          Buenos Aires del día. */}
      <CorreosDeLaManana
        bloques={bloques}
        fecha={fecha}
        hora={hora}
        datos={datos}
        planillaIds={[planillaId, furgonesId]}
        yo={yo}
        gula={gula}
      />
    </div>
  );
}
